import React from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Button } from '@components/Button';
import { Text } from '@components/typography';
import { Columns } from '@components/Columns';
import { JoykitIconVariant } from '@components/JoykitIcon';
import {
  StyledIconColumn,
  IconsWrapper,
  StyledIconLink,
  StyledHoveIcon,
  StyledThumbnailIcon,
  StyledSectionWrapper,
  StyledBox,
  BlogCenterTextPairing,
  StyledDepartmentColumn,
  StyledDesktopDepartmentColumn,
  FeatureText,
  StyledBorderColumn,
  StyledColumn,
  StyledCatalogColumn,
  StyledCatalogLink,
  ProductTitleText,
  ProductBodyText,
} from './RegistryPublicCatalogSection.styles';
import { CloudImage } from '@components/CloudImage';
import { registryPageData } from '@data-ts/pages/honeymoon-registry';
const analytics = require('../../../../static/js/joy');

export interface IconProps
  extends Readonly<{
    icon: JoykitIconVariant;
    text: string;
    url: string;
  }> {}

const publicCatalogSection = registryPageData.publicCatalogSection;
interface RegistryPublicCatalogSectionProps {}

export const RegistryPublicCatalogSection: React.FC<RegistryPublicCatalogSectionProps> = () => {
  const handleShopItemClick = (index: number, title: string, url: string) => {
    analytics.segment.sendTelemetryEvent('ShopItemClicked', {
      label: title,
      value: index,
      productCatalogItemId: new URL(url).pathname.split('/')[3],
      elementId: 'cross sell horizontal grid',
      productCatalogItemPosition: index,
    });
  };

  const renderIcons = (icons: ReadonlyArray<IconProps>) => {
    return icons.map((icon, index) => {
      return (
        <StyledIconColumn width={3} key={index}>
          <IconsWrapper flexDirection={'column'} alignItems="center" marginBottom={[8, 3]}>
            <StyledIconLink href={icon.url} target="_blank" id={`${icon.icon}-catalog`}>
              <Flex key={icon.icon + index} flexDirection="column" alignItems="center" style={{ width: '100%' }} margin={[0, 4]}>
                <StyledHoveIcon name={'catalogBgHover'} />
                <StyledThumbnailIcon name={icon.icon} />
                <Text variant="caption" className="department-text" tagName="span" color="neutra6" textAlign="center" marginTop={4}>
                  {icon.text}
                </Text>
              </Flex>
            </StyledIconLink>
          </IconsWrapper>
        </StyledIconColumn>
      );
    });
  };
  return (
    <StyledSectionWrapper as="section" id="Public_Catalog" marginTop={[10, 12]} marginBottom={[10, 12]}>
      <StyledBox alignItems="center">
        <BlogCenterTextPairing
          alignment="center"
          eyebrow={publicCatalogSection.eyebrow}
          eyebrowColor="humana5"
          eyebrowVariant="sectionEyeBrow20"
          eyebrowTagName="h2"
          title={publicCatalogSection.title}
          titleVariant="hed56"
          titleColor="neutra6"
          titleTagName="h2"
          body={publicCatalogSection.feature}
          bodyVariant="dek20"
          bodyColor={'neutra6'}
          bodyTagName="p"
        />
      </StyledBox>

      <StyledDepartmentColumn centered verticalAlign="flex-start" marginTop={[8, 10]} marginBottom={[8, 6]}>
        <Columns.Column width={12}>
          <FeatureText textAlign="center" tagName="h2" variant="featureHed17" color="neutra5">
            {publicCatalogSection.body}
          </FeatureText>
        </Columns.Column>
      </StyledDepartmentColumn>
      <StyledDepartmentColumn centered verticalAlign="flex-start">
        {renderIcons(publicCatalogSection.departmentIconList)}
      </StyledDepartmentColumn>
      <StyledDesktopDepartmentColumn centered verticalAlign="flex-start">
        <StyledBorderColumn width={12}></StyledBorderColumn>
      </StyledDesktopDepartmentColumn>
      <StyledColumn centered marginTop={[4, 10]} verticalAlign="flex-start" className="catlog-items">
        {publicCatalogSection.catlogList.map((item, index) => (
          <StyledCatalogColumn key={index} width={6} context={index}>
            <Flex alignItems="center" flexDirection="column" marginBottom={[8, 0]}>
              <StyledCatalogLink
                href={item.url}
                target="_blank"
                id={`${item.title}-catalog`}
                onClick={() => handleShopItemClick(index, item.body, item.url)}
              >
                <CloudImage src={item.image} width="100%" alt={item.title} isResizeDisabled={true} />
                <ProductTitleText variant="caption" tagName="h2" textAlign="center" marginTop={6}>
                  {item.title}
                </ProductTitleText>
                <ProductBodyText
                  variant="dek15"
                  tagName="span"
                  color="mono1"
                  textAlign="center"
                  marginTop={4}
                  marginLeft={'auto'}
                  marginRight={'auto'}
                >
                  {item.body}
                </ProductBodyText>
              </StyledCatalogLink>
            </Flex>
          </StyledCatalogColumn>
        ))}
      </StyledColumn>
      <Box style={{ textAlign: 'center' }} marginTop={[8, 10]}>
        <Button id="exploreShopBtn" href={publicCatalogSection.exploreShopButton.url} forwardedAs={'a'} variant="primary">
          {publicCatalogSection.exploreShopButton.label}
        </Button>
      </Box>
    </StyledSectionWrapper>
  );
};
